import React, { useState, useEffect, useContext } from 'react';
import { courseListOfStudent, totalMovingClassPrice, getCoursePrice, courseTransfer, newFetchTeacherByCourseId, changeLevel, getStudents } from '../../../../../Api/apiUtils';
import { Form, FormGroup, Label, Input } from 'reactstrap';
import { Badge, Button, DescriptionList, Field, Table, TextInput } from '../../../../../ui';
import { Actions, Callout, Dialog, FormGrid } from '../ui-pending';
import './changeCourse.scss';
import { ConfigContext, PaymentConfigContext, } from '../../../../../Api/global/ApiContext';
import { toast } from 'react-toastify';
import Select, { SingleValue, components, ControlProps } from 'react-select';
import { MixpanelEvents,trackEvent } from '../../../../../utils/mixpanelTracking';
import FindTeacher from '../findTeacher';
import { useRef } from "react";
interface Course {
  classesCount: number;
  purchasedLevel: string | null;
  courseName: string;
  courseId: string;
}

interface GroupedCourse {
  courseId: string;
  courseName: string;
  levels: { purchasedLevel: string | null; classesCount: number }[];
}

interface PaymentCourse {
  name: string;
  paidCourseId: string;
  demoCourseId: string;
  levels: {
    name: string;
    classsize: string;
    levelId: string;
  }[];
}

interface TotalMovingClassPriceResponse {
  totalClassPrice: number;
}

interface CourseChangeProps {
  studentId?: string;
}

const ChangeStudent: React.FC<any> = ({ studentId, profileData, courseData  }) => {
  const [courses, setCourses] = useState<Course[]>([]);
  const [students, setStudents] = useState<any[]>([]);
  const [noResults, setNoResults] = useState<boolean>(false);
  const [groupedCourses, setGroupedCourses] = useState<GroupedCourse[]>([]);
  const [selectedCourse, setSelectedCourse] = useState<{ value: string; label: string } | null>(null);
  const [selectedLevels, setSelectedLevels] = useState<{ [key: string]: number | '' }>({}); // Allow empty values
  const [amount, setAmount] = useState<number | null>(null);
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState<boolean>(true);
  const [paymentCourses, setPaymentCourses] = useState<PaymentCourse[]>([]);
  const [selectedPaymentCourse, setSelectedPaymentCourse] = useState<{ value: string; label: string } | null>(null);
  const [selectedPaymentLevels, setSelectedPaymentLevels] = useState<{ [key: string]: number | '' }>({}); // Allow empty values
  const [showPaymentFields, setShowPaymentFields] = useState<boolean>(false); // Control visibility of payment fields
  const [toCourseDetail, setToCourseDetail] = useState<any>(null);
  const [inputsDisabled, setInputsDisabled] = useState<boolean>(false);
  const [teachers, setTeachers] = useState<any[]>([]);
  const [selectedTeacher, setSelectedTeacher] = useState<any>("");
    const [selectedLevelId, setSelectedLevelId] = useState<string | null>(null);
  const [isFreeClass, setIsFreeClass] = useState<boolean | null>(null);
  const [showFreeClassSelection, setShowFreeClassSelection] = useState<boolean>(false);
  const [findTeacherModal, setFindTeacherModal]= useState<boolean>(false);
  const [selectedStudent, setSelectedStudent] = useState<{ value: string; label: string; userId: any; timezone?: string } | null>(null);
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const Userdetails = JSON.parse(localStorage.getItem("profileData") || "{}");

  const submitDebounceTimerRef = useRef<NodeJS.Timeout | null>(null);

  // Menu state for all Select components
  const [courseMenuIsOpen, setCourseMenuIsOpen] = useState<boolean>(false);
  const [paymentCourseMenuIsOpen, setPaymentCourseMenuIsOpen] = useState<boolean>(false);
  const [teacherMenuIsOpen, setTeacherMenuIsOpen] = useState<boolean>(false);

  // Custom Control component to ensure entire control area opens dropdown on click
  const CustomControl = (props: ControlProps<any, false>) => {
    const { innerProps, selectProps } = props;
    const menuIsOpen = selectProps.menuIsOpen;
    const onMenuOpen = selectProps.onMenuOpen;
    
    return (
      <components.Control
        {...props}
        innerProps={{
          ...innerProps,
          onMouseDown: (e: React.MouseEvent<HTMLDivElement>) => {
            if (!menuIsOpen && onMenuOpen) {
              e.preventDefault();
              e.stopPropagation();
              onMenuOpen();
            } else if (innerProps.onMouseDown) {
              innerProps.onMouseDown(e as any);
            }
          },
          onClick: (e: React.MouseEvent<HTMLDivElement>) => {
            if (!menuIsOpen && onMenuOpen) {
              e.preventDefault();
              e.stopPropagation();
              onMenuOpen();
            } else if (innerProps.onClick) {
              innerProps.onClick(e as any);
            }
          }
        }}
      />
    );
  };

  const CustomOption = (props: any) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className="cc-teacher-option"
      >
        <span>{data.label.split(' - ')[0]}</span>
        <span className="cc-teacher-option__meta ds-text-subtle">
        {data?.allocationPriority == "1" ? "PRIORITY - ":""} {data.workingStatus}
        </span>
      </div>
    );
  };
  

  const paymentConfig = useContext(PaymentConfigContext);
  const paymentcourse = paymentConfig?.onlineCourseAcademic2 || [];


  const fetchStudents = async (searchPayload: { 
    name?: string; 
    emailId?: string; 
    mobileNumber?: string; 
    studentId?: string;
    userId?: string;
    userType?: string 
  } = {}) => {
    setLoading(true);
    try {
      const response = await getStudents(0, 20, searchPayload);
      
      // Handle response like StudentList.tsx
      let studentData;
      if (Array.isArray(response)) {
        // API returns direct array
        studentData = response;
      } else if (response && response.content && Array.isArray(response.content)) {
        // API returns { content: [...] }
        studentData = response.content;
      } else if (response && response.students && Array.isArray(response.students.content)) {
        // API returns { students: { content: [...] } }
        studentData = response.students.content;
      } else {
        console.error("Unexpected API response structure:", response);
        setStudents([]);
        setNoResults(true);
        return;
      }
      
      // Filter out the current student from search results
      const filteredStudents = studentData.filter((student: any) => {
        const currentStudentId = studentId || profileData?.studentId || profileData?.userId;
        return student.studentId !== currentStudentId && student.userId !== currentStudentId;
      });
      
      setStudents(filteredStudents);
      setNoResults(filteredStudents.length === 0);
      
      // Debug log to see what data we're getting
      console.log("Fetched students (before filter):", studentData.length);
      console.log("Filtered students (after removing current student):", filteredStudents.length);
      console.log("Current student ID being filtered:", studentId || profileData?.studentId || profileData?.userId);
      
      // Check if students have the required fields
      filteredStudents.forEach((student: any, index: number) => {
        console.log(`Student ${index}:`, {
          studentId: student.studentId,
          studentName: student.studentName,
          mobileNumber: student.mobileNumber,
          emailId: student.emailId
        });
      });
      
    } catch (error) {
      console.error("There was an error fetching the student data!", error);
      setNoResults(true);
    } finally {
      setLoading(false);
    }
  };

const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);

const handleInputChange = (value: any) => {
  setInputValue(value);

  if (value.length >= 2) {
    setShowDropdown(true);
    let searchPayload: any = {};

    if (value.trim() !== "") {
      if (/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/gi.test(value)) {
        searchPayload = { emailId: value };
        console.log("Searching by email:", value);
      } else if (/^\+?\d+$/.test(value)) {
        const mobileNumber = value
          .replace(/^\+91|^\+1|^\+44/, "")
          .replace(/\D/g, "");
        searchPayload = { mobileNumber: mobileNumber };
        console.log("Searching by mobile number:", mobileNumber, "Original:", value);
      } else {
        searchPayload = { name: value };
        console.log("Searching by name:", value);
      }
    }

    console.log("Search payload:", searchPayload);

    // 🔹 Debounce API call
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    debounceTimeoutRef.current = setTimeout(() => {
      fetchStudents(searchPayload);
    }, 1000);

  } else {
    setShowDropdown(false);
    
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    debounceTimeoutRef.current = setTimeout(() => {
      fetchStudents();
    }, 1000);
  }
};

  useEffect(() => {
    const fetchCourses = async () => {
      if (!studentId) return;

      try {
        const response = await courseListOfStudent(studentId);
        setCourses(response);
        setLoading(false);
      } catch (error) {
        toast.error('Failed to fetch course list.');
        setLoading(false);
      }
    };

    fetchCourses();
  }, [studentId]);

  // Fetch students and initialize selectedStudent
  useEffect(() => {
    const initializeStudents = async () => {
      try {
        await fetchStudents();

        if (studentId) {
          // Find the student in the fetched students list to get proper name
          const currentStudent = students.find(student => 
            (student.studentId || student.userId) === studentId
          );
          if (currentStudent) {
            setSelectedStudent({ 
              userId: currentStudent.userId,
              value: studentId, 
              label: currentStudent.studentName || 'Student'
            });
          } 
        //   else {
        //     setSelectedStudent({ value: studentId, label: `Student ${studentId}` });
        //   }
        }
      } catch (error) {
        console.error('Error initializing students:', error);
      }
    };

    initializeStudents();
  }, [studentId]);

  useEffect(() => {
          if (!selectedPaymentCourse) return;
  
          const fetchTeachers = async () => {
              setLoading(true);
  
              try {
                  const courseId = selectedPaymentCourse?.value;
                  const payload = {
                      page: 0,
                      size: 500,
                      courseId: courseId,
                  };
  
                  const response = await newFetchTeacherByCourseId( payload);
                  if (response.data && Array.isArray(response.data.content)) {
                      setTeachers(response.data.content);
                  } else {
                      toast.error("Unexpected API response format.");
                      setTeachers([]);
                  }
              } catch (error) {
                  console.error("Error fetching teachers:", error);
                  toast.error("Failed to fetch teachers. Please try again.");
                  setTeachers([]);
              } finally {
                  setLoading(false);
              }
          };
  
          fetchTeachers();
      }, [selectedPaymentCourse]);

  // Group courses by courseId and courseName
  useEffect(() => {
    if (courses.length > 0) {
      const grouped = courses.reduce((acc, course) => {
        const existingCourse = acc.find(c => c.courseId === course.courseId);
        if (existingCourse) {
          existingCourse.levels.push({
            purchasedLevel: course.purchasedLevel,
            classesCount: course.classesCount,
          });
        } else {
          acc.push({
            courseId: course.courseId,
            courseName: course.courseName,
            levels: [{ purchasedLevel: course.purchasedLevel, classesCount: course.classesCount }],
          });
        }
        return acc;
      }, [] as GroupedCourse[]);
      setGroupedCourses(grouped);
    }
  }, [courses]);

  useEffect(() => {
    if (selectedCourse) {
      const course = groupedCourses.find(c => c.courseId === selectedCourse.value);
      if (course) {
        const initialLevels = course.levels.reduce((acc, level) => {
          acc[level.purchasedLevel || 'default'] = level.classesCount;
          return acc;
        }, {} as { [key: string]: number | '' });
        setSelectedLevels(initialLevels);
      }
    }
  }, [selectedCourse, groupedCourses]);

  useEffect(() => {
    if (paymentcourse.length > 0) {
      setPaymentCourses(paymentcourse);
    }
  }, [paymentcourse]);

  useEffect(() => {
    if (selectedPaymentCourse) {
      const course = paymentCourses.find(c => c.paidCourseId === selectedPaymentCourse.value);
      if (course) {
        const initialLevels = course.levels.reduce((acc, level) => {
          acc[level.levelId] = parseInt(level.classsize, 10);
          return acc;
        }, {} as { [key: string]: number | '' });
        setSelectedPaymentLevels(initialLevels);
      }
    }
  }, [selectedPaymentCourse, paymentCourses]);

  const handleCourseChange = (selectedOption: { value: string; label: string } | null) => {
    setSelectedCourse(selectedOption);
  };

  const handlePaymentCourseChange = async (selectedOption: { value: string; label: string } | null) => {
    setSelectedTeacher("");
    setSelectedPaymentCourse(selectedOption);
    console.log("paymentcourse", selectedPaymentCourse);
    let toCousreDetails = paymentCourses.find(c => c.paidCourseId == selectedOption?.value) || ({} as any);
    if (toCousreDetails) {
      let levelIds = ([] as any);
      const courseList = (toCousreDetails?.levels || []).map((lev: any) => {
        levelIds.push(lev.levelId);
        return {
          courseId: toCousreDetails.paidCourseId?.toString(),
          levelId: lev.levelId.toString(),
          courseName: toCousreDetails.name,
          level: lev.name,
          classesToPurchase: 0,
          classCount: lev.classsize.toString()
        };
      });
      //const walletDetails = await walletPoints(userId, userType.toLowerCase());
      let priceCCObj = (paymentConfig?.timezoneWithCountryName && paymentConfig?.timezoneWithCountryName[profileData.timezone]);
      const priceDetails = await getCoursePrice(levelIds.map(Number), priceCCObj.code, priceCCObj.country.toLowerCase());
      let mergedData;
      if (courseList.length && priceDetails && priceDetails.data) {
        // if (accountDetails.length == levelIds.length && courseList.length && priceData.data && priceData.data.data) {
        mergedData = courseList.map((course: any) => {
          const levelId = course.levelId.toString();
          const priceInfo = priceDetails.data.find((price: any) => price.levelId === Number(levelId));
          return {
            ...course,
            unit_price: priceInfo ? priceInfo.price : null,
            priceWithoutGST: priceInfo && priceInfo.currency == 'INR' ? (priceInfo.price / 1.18).toString() : priceInfo.price.toString(),
            priceWithoutGSTRound: priceInfo && priceInfo.currency == 'INR' ? +((priceInfo.price / 1.18).toFixed(2)) : +(priceInfo.price.toFixed(2)),
            gst: priceInfo && priceInfo.currency == 'INR' ? 1.18 : 0,
            currency: priceInfo ? priceInfo.currency : null,
          };
        });
      }
      let toCourseObj = {} as any;
      toCourseObj.levelList = mergedData;
      toCourseObj.currency = mergedData[0].currency;
      toCourseObj.discountPercentage = 0;
      toCourseObj.discountedTotal = 0;
      toCourseObj.totalPrice = 0;
      setToCourseDetail(calculateTotalPrice(toCourseObj));
    } else {
      setToCourseDetail(null);
    }

  };

  const handleLevelChange = (level: string | null, value: string) => {
    const numericValue = value === '' ? '' : parseInt(value, 10);
    const course = groupedCourses.find(c => c.courseId === selectedCourse?.value);
    if (course) {
      const levelData = course.levels.find(l => l.purchasedLevel === level);
      if (
        levelData &&
        (numericValue === '' || (numericValue <= levelData.classesCount && numericValue >= 0))
      ) {
        setSelectedLevels((prev) => ({
          ...prev,
          [level || 'default']: numericValue,
        }));
      } else {
        toast.error(`Class count cannot exceed ${levelData?.classesCount}.`);
      }
    }
  };

  const handlePaymentLevelChange = (levelId: string, value: string) => {
    const numericValue = value === '' ? '' : parseInt(value, 10); // Allow empty string
    const course = paymentCourses.find(c => c.paidCourseId === selectedPaymentCourse?.value);
    if (course) {
      const levelData = course.levels.find(l => l.levelId === levelId);
      if (
        levelData &&
        (numericValue === '' || (numericValue <= parseInt(levelData.classsize, 10) && numericValue >= 0))
      ) {

        setSelectedPaymentLevels((prev) => ({
          ...prev,
          [levelId]: numericValue,
        }));
      } else {
        toast.error(`Class count cannot exceed ${levelData?.classsize}.`);
      }
    }
  };


  const handleChangeCourseSubmit = async () => {
    // Clear any existing timer
    if (submitDebounceTimerRef.current) {
      clearTimeout(submitDebounceTimerRef.current);
    }

    // Prevent multiple rapid clicks
    if (loading) {
      return;
    }

    // Set a debounce timer to prevent double clicks
    submitDebounceTimerRef.current = setTimeout(async () => {
      if (!selectedCourse || !selectedPaymentCourse || !studentId || !toCourseDetail || !selectedStudent ) {
        toast.error('Please select both from and to courses and ensure studentId is provided.');
        return;
      }

      if (!selectedStudent) {
        toast.error('Please select a student');
        setLoading(false);
        return;
      }

      // Validate currency match between current student and selected student based on timezone
      if (!profileData?.timezone) {
        toast.error('Current student timezone information is missing. Cannot validate currency.');
        setLoading(false);
        return;
      }

      if (!selectedStudent.timezone) {
        toast.error('Selected student timezone information is missing. Cannot validate currency.');
        setLoading(false);
        return;
      }

      // Normalize timezones for comparison (case-insensitive)
      const currentTimezone = (profileData.timezone || '').toLowerCase();
      const selectedTimezone = (selectedStudent.timezone || '').toLowerCase();
      
      // Check if timezone is domestic (Asia/Kolkata or Asia/Calcutta)
      const isDomesticTimezone = (tz: string) => {
        return tz === 'asia/kolkata' || tz === 'asia/calcutta';
      };
      
      const currentIsDomestic = isDomesticTimezone(currentTimezone);
      const selectedIsDomestic = isDomesticTimezone(selectedTimezone);
      
      // Both should be domestic OR both should be international
      if (currentIsDomestic !== selectedIsDomestic) {
        const currentStudentType = currentIsDomestic ? 'Domestic' : 'International';
        const selectedStudentType = selectedIsDomestic ? 'Domestic' : 'International';
        toast.error(`Can't transfer the course with ${currentStudentType} to ${selectedStudentType} student`);
        setLoading(false);
        return;
      }

      setLoading(true);
    const fromCourseLevels = Object.entries(selectedLevels)
      .filter(([_, classesCount]) => classesCount !== '' && classesCount !== 0)
      .map(([level, classesCount]) => ({
        level: level === 'default' ? null : level,
        courseName: groupedCourses.find(c => c.courseId === selectedCourse.value)?.courseName || "",
        noOfClasses: classesCount as number,
      }));

    const toCourseLevels = toCourseDetail.levelList
      .filter((level: any) => level.classCount !== '' && level.classCount !== 0)
      .map((level: any) => {
        const discount = +((+level.unit_price * +level.classCount * toCourseDetail.discountPercentage) / 100).toFixed(2);
        let finalAmount = +((+level.unit_price * +level.classCount) - +discount).toFixed(2);
        let amountExcludeGST = +(finalAmount / 1.18).toFixed(2);
        let gstAmount = (+finalAmount - amountExcludeGST).toFixed(2);
        return {
          returnlevel: level.level,
          courseId: level.courseId,
          levelId: level.levelId,
          level: level.level,
          courseName: level.courseName,
          noOfClasses: +level.classCount,
          totalFinalPrice: finalAmount,
          totalGstAmount: level.currency == "INR" ? gstAmount : 0,
          totalDiscount: discount,
          unit_price: level.unit_price
        };
      });

    const totalMovedClasses = toCourseLevels.reduce((sum: any, level: any) => sum + level.noOfClasses, 0);
    if (!selectedLevelId) {
      toast.error('Please select a level');
      setLoading(false)
      return;
    }

    const totalRemovedClasses  = fromCourseLevels.reduce((sum: any, level: any) => sum + level.noOfClasses, 0);
    if (!selectedLevelId) {
      toast.error('Please select a level');
      setLoading(false)
      return;
    }
    if (!selectedTeacher.value) {
      toast.error('Please select teacher');
      setLoading(false)
      return;
    }
    const payload = {
      fromStudentId: studentId,
      toStudentId: selectedStudent.value,
      userId: selectedStudent.userId || "",
      name: selectedStudent.label,
      toStudentName: selectedStudent.label,
      fromStudentName: profileData.firstName,
      prefix: "SC",
      adminUser: Userdetails?.firstName,
      isFreeClass: isFreeClass,
      teacherId: (selectedTeacher as any).value,
      totalMovedClasses,
      totalRemovedClasses,
      walletAmount: Math.max(0, Math.round(+(amount || 0) - +toCourseDetail.discountedTotal)),
      fromCourse: {
        courseId: selectedCourse.value,
        removeLevels: fromCourseLevels,
      },
      toCourse: {
        courseId: selectedPaymentCourse.value,
        addLevels: toCourseLevels,
      }
    };

    if (amount !== 0 && Math.round(+(amount || 0) - +toCourseDetail.discountedTotal) < 0) {
      toast.error('Existing Course Amount should not be greater than New Course Amount');
      setLoading(false)
      return;
    }
    try {
      const response = await courseTransfer(payload);
      //console.log("payload", payload);
      if (response) {
        try {
          // const changeLevelPayload = {
          //   userId: profileData.userId, 
          //   courseId: selectedPaymentCourse.value,
          //   levelId: selectedLevelId, 
          //   // reason: "course change", // You can customize this
          //   changeType: "course",
          //   previousCourseId: selectedCourse.value
          // };


                      trackEvent(MixpanelEvents.COURSE_TRANSFER, {
                        page:"Course Change in student profile",
                        courseId: selectedPaymentCourse.value,
                        levelId: selectedLevelId, 
                        previousCourseId: selectedCourse.value,
                        totalMovedClasses: totalMovedClasses,
                        totalRemovedClasses:  totalRemovedClasses,
                        studentId:studentId,
                        userId: profileData.userId, 

                 
                   
                      });
          
          // const levelChangeResponse = await changeLevel(changeLevelPayload);
          // if (levelChangeResponse) {
            toast.success('Course Transferred successfully!');
            setLoading(false);
          // } else {
          //   toast.success('Course changed successfully, but level change failed!');
          // }
        } catch (levelError) {
          console.error('Error changing level:', levelError);
          toast.success('Course changed successfully, but level change failed!');
        }

        // Reset form fields
        setSelectedCourse(null);
       setShowFreeClassSelection (false);
        setSelectedPaymentCourse(null);
        setSelectedLevels({});
        setSelectedPaymentLevels({});
        setShowPaymentFields(false);
        setAmount(null);
        setSelectedLevelId(null); // Reset selected level
        setToCourseDetail(null);
        setSelectedStudent(null);
      } else {
        toast.error('Failed to change course.');
      }
    } catch (error) {
      toast.error('Failed to change course.');
      console.error('Error changing course:', error);
    } finally {
      setLoading(false); // Stop loading in all cases
    }
    }, 1000); // 1000ms debounce delay
  };
  const handleReset = () => {
    setIsFreeClass(null);
    setInputsDisabled(false);
    setSelectedPaymentCourse(null);
    setShowFreeClassSelection(false);
    setSelectedPaymentLevels({});
    setShowPaymentFields(false);
    setAmount(null);
    setToCourseDetail(null);
    setSelectedStudent(null);
  };

  const handleSubmit = async () => {
    if (!selectedCourse || !studentId) {
      toast.error('Please select a course and ensure studentId is provided.');
      return;
    }
  
    const payload = Object.entries(selectedLevels).map(([level, classesCount]) => {
      const processedLevel = level === 'default' ? '' : level;
      if (!processedLevel && processedLevel !== '') {
        toast.error('Invalid level value detected');
        throw new Error('Invalid level');
      }
  
      return {
        studentId,
        courseId: selectedCourse.value,
        noOfClasses: classesCount === '' ? 0 : Number(classesCount),
        level: processedLevel
      };
    });
  
    try {
      const validPayload = payload.filter(a => {
        if (a.noOfClasses > 0 && a.level === undefined) {
          toast.error(`Missing level for entry with ${a.noOfClasses} classes`);
          return false;
        }
        return a.noOfClasses > 0;
      });
  
      if (validPayload.length === 0) {
        toast.error('No valid class entries to submit');
        return;
      }
  
      const response = await totalMovingClassPrice(validPayload);
      
      if (response.status < 200 || response.status >= 300) {
        const apiError = response.data?.message || 
                        response.data?.error || 
                        `Request failed with status ${response.status}`;
        toast.error(apiError);
        return;
      }
  
      const data = response.data as TotalMovingClassPriceResponse;
      setAmount(data.totalClassPrice);
      
      // Show free class selection if amount is 0
      if (data.totalClassPrice === 0) {
        setShowFreeClassSelection(true);
      } else {
        setInputsDisabled(true);
        setShowPaymentFields(true);
      }
      
    } catch (error: any) {
      let errorMessage = 'Failed to submit course change';
      
      if (error.response) {
        errorMessage = error.response.data;
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      toast.error(errorMessage);
      console.error('API Error Details:', {
        error: error.response?.data || error.message,
        payload: payload,
        status: error.response?.status
      });
    }
  };

  const handleFreeClassSelection = (value: boolean) => {
    setIsFreeClass(value);
    if (value) {
      // If free class is selected, set all prices to 0
      if (toCourseDetail) {
        const updatedToCourseDetail = {
          ...toCourseDetail,
          levelList: toCourseDetail.levelList.map((level: any) => ({
            ...level,
            unit_price: 0,
            priceWithoutGST: 0,
            priceWithoutGSTRound: 0,
            classCount: level.classCount // Preserve the class count
          })),
          total: 0,
          discountedTotal: 0,
          currency: toCourseDetail.currency // Preserve the currency
        };
        setToCourseDetail(updatedToCourseDetail);
      }
    } else {
      // If free class is not selected, restore original prices
      if (toCourseDetail) {
        const course = paymentCourses.find(c => c.paidCourseId === selectedPaymentCourse?.value);
        if (course) {
          const levelIds = course.levels.map((lev: any) => lev.levelId);
          const priceCCObj = (paymentConfig?.timezoneWithCountryName && paymentConfig?.timezoneWithCountryName[profileData.timezone]);
          
          // Fetch original prices again
          getCoursePrice(levelIds.map(Number), priceCCObj.code, priceCCObj.country.toLowerCase())
            .then((priceDetails) => {
              if (priceDetails && priceDetails.data) {
                const courseList = course.levels.map((lev: any) => {
                  const priceInfo = priceDetails.data.find((price: any) => price.levelId === Number(lev.levelId));
                  return {
                    courseId: course.paidCourseId?.toString(),
                    levelId: lev.levelId.toString(),
                    courseName: course.name,
                    level: lev.name,
                    classesToPurchase: 0,
                    classCount: lev.classsize.toString(),
                    unit_price: priceInfo ? priceInfo.price : null,
                    priceWithoutGST: priceInfo && priceInfo.currency == 'INR' ? (priceInfo.price / 1.18).toString() : priceInfo.price.toString(),
                    priceWithoutGSTRound: priceInfo && priceInfo.currency == 'INR' ? +((priceInfo.price / 1.18).toFixed(2)) : +(priceInfo.price.toFixed(2)),
                    gst: priceInfo && priceInfo.currency == 'INR' ? 1.18 : 0,
                    currency: priceInfo ? priceInfo.currency : null,
                  };
                });

                const updatedToCourseDetail = {
                  levelList: courseList,
                  currency: courseList[0].currency,
                  discountPercentage: 0,
                  discountedTotal: 0,
                  total: 0
                };
                setToCourseDetail(calculateTotalPrice(updatedToCourseDetail));
              }
            })
            .catch((error) => {
              console.error('Error fetching prices:', error);
              toast.error('Failed to restore original prices');
            });
        }
      }
    }
    setInputsDisabled(true);
    setShowPaymentFields(true);
  };

  const handleClassCount = (level: any, value: string | number) => {
    let sanitizedValue = typeof value === "string"
      ? value.replace(/[^0-9]/g, '')  // Remove non-numeric characters
      : value;
    const newLevelList = toCourseDetail.levelList.map((l: any, i: number) => {
      if (l.levelId === level.levelId) {
        return {
          ...l,
          classCount: +sanitizedValue,
        };
      }
      return l;
    });

    const newToCourseDetail = {
      ...toCourseDetail,
      levelList: newLevelList,
    };

    setToCourseDetail(calculateTotalPrice(newToCourseDetail));
  };

  const handleDiscountChange = (type: string, value: string | number) => {
    let sanitizedValue: string | number = typeof value === "string"
      ? value.replace(/[^0-9]/g, '') // Remove non-numeric characters
      : value;


    const numericValue = typeof sanitizedValue === "string"
      ? sanitizedValue === '' ? 0 : parseInt(sanitizedValue, 10)
      : sanitizedValue;


    const clampedValue = Math.min(Math.max(numericValue, 0), 100);

    const newToCourseDetail = {
      ...toCourseDetail,
      [type]: +clampedValue,
    };

    setToCourseDetail(calculateTotalPrice(newToCourseDetail));
  };

  const calculateTotalPrice = (toCourseData: any) => {
    let plan = JSON.parse(JSON.stringify(toCourseData));
    let levelList = plan.levelList;

    plan.classCount = levelList.reduce((acc: any, level: any) => acc + +level.classCount, 0);
    plan.total = Math.max(+levelList.reduce((acc: any, level: any) => acc + +(level.classCount * level.unit_price).toFixed(2), 0), 0);
    plan.discountedTotal = Math.max(+(plan.total - (plan.total * +((plan.discountPercentage) / 100))).toFixed(2), 0);
    plan.discountedTotalwithFlash = Math.max(+(plan.total - (plan.total * +((plan.discountPercentage + plan.specialDiscountPercentage + plan.additionalDiscountPercentage + plan.flashDiscountPercentage) / 100))).toFixed(2), 0);
    return plan;
  }

  // Handle outside clicks to close dropdowns
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const isClickInsideSelect = target.closest('.react-select-container') || 
                                   target.closest('[class*="react-select"]') ||
                                   target.closest('[id*="react-select"]') ||
                                   target.closest('[class*="css-"]');
      
      if (!isClickInsideSelect) {
        setCourseMenuIsOpen(false);
        setPaymentCourseMenuIsOpen(false);
        setTeacherMenuIsOpen(false);
      }
      
      if (!target.closest('.student-search-container')) {
        setShowDropdown(false);
      }
    };

    if (showDropdown || courseMenuIsOpen || paymentCourseMenuIsOpen || teacherMenuIsOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown, courseMenuIsOpen, paymentCourseMenuIsOpen, teacherMenuIsOpen]);

  // Cleanup submit debounce timer on component unmount
  useEffect(() => {
    return () => {
      if (submitDebounceTimerRef.current) {
        clearTimeout(submitDebounceTimerRef.current);
      }
    };
  }, []);

  return (
    <>
      <Form className="ds-stack">
        <Field label="Select student course">
          {(ctl) => (
            <Select
              isDisabled={inputsDisabled}
              id="courseSelect"
              inputId={ctl.id}
              value={selectedCourse}
              onChange={(newValue) => {
                handleCourseChange(newValue);
                setCourseMenuIsOpen(false);
              }}
              options={groupedCourses.map(course => ({ value: course.courseId, label: course.courseName }))}
              placeholder="Select a course"
              menuIsOpen={courseMenuIsOpen}
              onMenuOpen={() => setCourseMenuIsOpen(true)}
              onMenuClose={() => setCourseMenuIsOpen(false)}
              components={{ Control: CustomControl }}
            />
          )}
        </Field>

        {selectedCourse && (
          <>
            <FormGrid min={180}>
              {groupedCourses
                .find(c => c.courseId === selectedCourse.value)
                ?.levels.map((level, index) => (
                  <Field key={index} id={`level-${level.purchasedLevel}`} label={`${level.purchasedLevel || 'No Level'} - Class Count`}>
                    {(ctl) => (
                      <TextInput
                        {...ctl}
                        type="number"
                        value={selectedLevels[level.purchasedLevel || 'default']}
                        onChange={(e) =>
                          handleLevelChange(level.purchasedLevel, e.target.value)
                        }
                        min={0}
                        max={
                          groupedCourses
                            .find(c => c.courseId === selectedCourse.value)
                            ?.levels.find(l => l.purchasedLevel === level.purchasedLevel)?.classesCount
                        }
                        disabled={inputsDisabled}
                      />
                    )}
                  </Field>
                ))}

              {amount !== null && (
                <Field id="totalAmount" label="Total Amount">
                  {(ctl) => (
                    <TextInput
                      {...ctl}
                      disabled
                      type="text"
                      value={amount.toFixed(2)}
                      readOnly
                    />
                  )}
                </Field>
              )}
            </FormGrid>

            <Actions align="start">
              <Button variant="secondary" onClick={handleSubmit}>Get Class Amount</Button>
              <Button variant="ghost" onClick={handleReset}>Reset</Button>
            </Actions>
          </>
        )}

        {showFreeClassSelection && (
          <fieldset>
            <legend className="ds-field__label">Please confirm: is this a free class?</legend>
            <FormGroup check>
              <Label check>
                <Input
                  isDisabled={inputsDisabled}
                  className="levelChk"
                  type="radio"
                  name="freeClass"
                  checked={isFreeClass === true}
                  onChange={() => handleFreeClassSelection(true)}
                />{' '}
                Yes
              </Label>
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input
                  isDisabled={inputsDisabled}
                  className="levelChk"
                  type="radio"
                  name="freeClass"
                  checked={isFreeClass === false}
                  onChange={() => handleFreeClassSelection(false)}
                />{' '}
                No
              </Label>
            </FormGroup>
          </fieldset>
        )}

        {showPaymentFields && (
          <>
            <FormGrid>
              <Field label="Select the course to change">
                {(ctl) => (
                  <Select
                    id="paymentCourseSelect"
                    inputId={ctl.id}
                    value={selectedPaymentCourse}
                    onChange={(newValue) => {
                      handlePaymentCourseChange(newValue);
                      setPaymentCourseMenuIsOpen(false);
                    }}
                    options=
                    {paymentCourses.map(course =>
                       ({ value: course.paidCourseId, label: course.name }))}
                    placeholder="Select a payment course"
                    menuIsOpen={paymentCourseMenuIsOpen}
                    onMenuOpen={() => setPaymentCourseMenuIsOpen(true)}
                    onMenuClose={() => setPaymentCourseMenuIsOpen(false)}
                    components={{ Control: CustomControl }}
                  />
                )}
              </Field>

              <Field label="Search student" className="cc-student-search student-search-container">
                {(ctl) => (
                  <>
                    <TextInput
                      {...ctl}
                      type="text"
                      placeholder="Search by name, email, or mobile number"
                      value={inputValue}
                      onChange={(e) => handleInputChange(e.target.value)}
                    />
                    {showDropdown && students.length > 0 && (
                      <div className="cc-student-search__menu">
                        {students.map((student: any) => (
                          <button
                            type="button"
                            className="cc-student-search__option"
                            key={student.studentId}
                            onClick={() => {
                              setSelectedStudent({
                                userId: student.userId,
                                value: student.studentId,
                                label: student.studentName,
                                timezone: student.timezone || student.timeZone
                              });
                              setInputValue(student.studentName);
                              setShowDropdown(false);
                            }}
                          >
                            {student.studentName}
                          </button>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </Field>

              {selectedStudent && (
                <Callout tone="neutral" className="cc-selected-student">
                  Selected Student: {selectedStudent.label}
                </Callout>
              )}
            </FormGrid>

            <Field label="Select the teacher">
              {(ctl) => (
                <div className="cc-teacher-row">
                  <div className="cc-teacher-row__select">
                      <Select
                        id="paymentTeacherSelect"
                        inputId={ctl.id}
                        value={selectedTeacher}
                        onChange={(selectedOption: any) => {
                          setSelectedTeacher(selectedOption);
                          setTeacherMenuIsOpen(false);
                        }}
                        options={teachers.filter(teacher => teacher.workingStatus === "ACTIVE"
                            &&  teacher.enableForPaid === "true"
                          )
                          .sort((a, b) => {
                            const priorityA = a.allocationPriority === "1" ? 0 : 1;
                            const priorityB = b.allocationPriority === "1" ? 0 : 1;
                            return priorityA - priorityB;
                          }).map(teacher => ({
                            value: teacher.teacherId,
                            label: `${teacher.teacherName} - ${teacher.workingStatus}`,
                            workingStatus: teacher.workingStatus,
                            allocationPriority: teacher.allocationPriority
                          }))
                        }
                        placeholder="Select a teacher"
                        components={{ Option: CustomOption, Control: CustomControl }}
                        menuIsOpen={teacherMenuIsOpen}
                        onMenuOpen={() => setTeacherMenuIsOpen(true)}
                        onMenuClose={() => setTeacherMenuIsOpen(false)}
                      />
                  </div>
                  <span className="ds-text-muted">or</span>
                  <Button variant="secondary" size="sm" onClick={() => setFindTeacherModal(true)}>
                    Find Teacher
                  </Button>
                </div>
              )}
            </Field>

            {toCourseDetail && (
              <>
                <Table caption="Transfer course pricing" className="cc-pricing">
                  <thead>
                    <tr>
                      <th>Active Level</th>
                      <th>Class Count</th>
                      <th>Class Price</th>
                      <th>Discount (%)</th>
                      <th className="cc-pricing__detail">
                        Price Detail ({toCourseDetail.currency})
                        {isFreeClass && <> <Badge tone="success">Free class</Badge></>}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div className="cc-pricing__levels">
                          {toCourseDetail.levelList.map((level: any, index: number) => (
                            <div key={index} className="cc-pricing__level">
                              <span>{level.level}</span>
                              <Input
                                type="radio"
                                name="selectedLevel"
                                aria-label={`Select ${level.level}`}
                                value={level.levelId}
                                checked={selectedLevelId === level.levelId}
                                onChange={() => setSelectedLevelId(level.levelId)}
                              />
                            </div>
                          ))}
                        </div>
                      </td>
                      <td>
                        <div className="cc-pricing__levels">
                          {toCourseDetail.levelList.map((level: any, index: number) => (
                            <div key={index} className="cc-pricing__level">
                              <span>{level.level}</span>
                              <TextInput
                                size="sm"
                                className="cc-pricing__input"
                                aria-label={`${level.level} class count`}
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                value={level.classCount}
                                onChange={(e) => {
                                  const newValue = e.target.value;
                                  handleClassCount(level, newValue);
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      </td>
                      <td>
                        <div className="cc-pricing__levels">
                          {toCourseDetail.levelList.map((level: any, index: number) => (
                            <div key={index} className="cc-pricing__level">
                              <span className="cc-pricing__spacer" aria-hidden="true">{level.level}</span>
                              <TextInput
                                size="sm"
                                className="cc-pricing__input"
                                aria-label={`${level.level} class price`}
                                type="text"
                                disabled={true}
                                value={isFreeClass ? 0 : level.unit_price}
                                inputMode="numeric"
                                pattern="[0-9]*"
                              />
                            </div>
                          ))}
                        </div>
                      </td>
                      <td>
                        <TextInput
                          size="sm"
                          className="cc-pricing__input"
                          aria-label="Discount percentage"
                          type="number"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          value={isFreeClass ? 0 : toCourseDetail.discountPercentage}
                          onChange={(e) => handleDiscountChange('discountPercentage', Number(e.target.value))}
                          disabled={isFreeClass === true}
                        />
                      </td>
                      <td className="cc-pricing__detail">
                        <div className="cc-pricing__summary">
                          <DescriptionList
                            items={[
                              { label: 'Existing course total', value: <span className="ds-num">{amount?.toFixed(2)} {toCourseDetail.currency}</span> },
                              { label: 'New course total', value: <span className="ds-num">{isFreeClass ? 0 : Math.round(Number(toCourseDetail.discountedTotal))} {toCourseDetail.currency}</span> },
                            ]}
                          />
                          {!showFreeClassSelection && toCourseDetail.discountedTotal > +(amount || 0) ? (
                            <Callout tone="danger">
                              Existing course amount should not exceed than new course amount
                            </Callout>
                          ) : (
                            ( !showFreeClassSelection && +(amount || 0) - (isFreeClass ? 0 : toCourseDetail.discountedTotal)) ? (
                              <Callout tone="info">
                                Balance amount {(+(amount || 0) - (isFreeClass ? 0 : toCourseDetail.discountedTotal)).toFixed(2)} {toCourseDetail.currency} will be add in student wallet.
                              </Callout>
                            ) : ""
                          )}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>

                <Actions>
                  <Button
                    variant="primary"
                    loading={loading}
                    onClick={handleChangeCourseSubmit}
                  >
                    {loading ? 'Processing...' : 'Transfer Course'}
                  </Button>
                </Actions>
              </>
            )}
          </>
        )}
      </Form>

      <Dialog isOpen={findTeacherModal} onClose={() => setFindTeacherModal(false)} title="Find Teacher" size="xl" className="find-teacher-dialog">
        <FindTeacher
          studentId={studentId}
          profileData={profileData}
          preselectedCourseId={selectedPaymentCourse?.value}
          onTeacherSelect={(teacher) => {
            setSelectedTeacher({
              value: teacher.teacherId,
              label: `${teacher.firstName} ${teacher.lastName}`,
              // workingStatus: teacher.workingStatus || '',
              // allocationPriority: teacher.allocationPriority || ''
            });
            setFindTeacherModal(false);
          }}
          disableCourseSelect={true}
        />
      </Dialog>
    </>
  );
};

export default ChangeStudent;